export const allItemTop = [
  {
    text: "Ultra",
    to: "/ultra",
    subMenu: [
      { text: "Activate", to: "activate" },
      { text: "Deactivate", to: "deactivate" },
      { text: "Change Number", to: "change_number" },
      { text: "Change Plan", to: "change_plan" },
      { text: "Pause", to: "pause" },
      { text: "Unpause", to: "unpause" },
      { text: "Restore", to: "restore" },
      { text: "Portin", to: "portin" },
      { text: "Change SIM", to: "change_sim" },
      { text: "Sim Info", to: "sim_info" },
      { text: "Reset", to: "reset" },
      { text: "Esim", to: "esim" },
      { text: "Wifi Calling", to: "wifi_calling" },
      { text: "IMSI Workflow", to: "imsi_workflow" },
      { text: "Credential", to: "credential" },
    ],
  },
  {
    text: "Telit",
    to: "/telit",
    subMenu: [
      { text: "Activate", to: "activate" },
      { text: "Deactivate", to: "deactivate" },
      { text: "Change Number", to: "change_number" },
      { text: "Change Plan", to: "change_plan" },
      { text: "Pause", to: "pause" },
      { text: "Sim Info", to: "sim_info" },
      { text: "Reset", to: "reset" },
      { text: "Credential", to: "credential" },
    ],
  },
  {
    text: "Sparq",
    to: "/sparq",
    subMenu: [
      { text: "Activate", to: "activate" },
      { text: "Deactivate", to: "deactivate" },
      { text: "IMSI Create", to: "imsi/imsi_create" },
      { text: "IMSI Delete", to: "imsi/imsi_delete" },
      { text: "IMSI Status", to: "imsi_status" },
      { text: "IMSI Reset", to: "imsi_reset" },
      { text: "Credential", to: "credential" },
    ],
  },
  {
    text: "Cricket",
    to: "/cricket",
    subMenu: [
      { text: "Activate", to: "activate" },
      { text: "Refill", to: "refill" },
      { text: "Credential", to: "credential" },
    ],
  },
  {
    text: "Verizon",
    to: "/verizon",
    subMenu: [
      { text: "Activate", to: "activate" },
      { text: "Refill", to: "refill" },
      { text: "Credential", to: "credential" },
    ],
  },
  {
    text: "T-Mobile",
    to: "/tmobile",
    subMenu: [
      { text: "Activate", to: "activate" },
      { text: "Credential", to: "credential" },
    ],
  },
  {
    text: "Selectel",
    to: "/selectel",
    subMenu: [
      { text: "Change Number", to: "change_number" },
      { text: "Change SIM", to: "change_sim" },
      { text: "Pause", to: "pause" },
      { text: "Unpause", to: "unpause" },
      { text: "Hotline", to: "hotline" },
      { text: "Sim Info", to: "sim_info" },
      { text: "Credential", to: "credential" },
    ],
  },
  {
    text: "OPN",
    to: "/opn",
    subMenu: [
      { text: "Sim Info", to: "sim_info" },
      { text: "Activate", to: "activate" },
      { text: "Refill", to: "refill" },
      { text: "Deactivate", to: "deactivate" },
      { text: "Credential", to: "credential" },
    ],
  },
  {
    text: "Tmobilej",
    to: "/tmobilej",
    subMenu: [
      { text: "Activate", to: "activate" },
      { text: "Change Number", to: "change_number" },
      { text: "Change Number Workaround", to: "change_number_workaround" },
      { text: "Change SIM", to: "change_sim" },
      { text: "Deactivate", to: "deactivate" },
      { text: "Restore", to: "restore" },
      { text: "Clear Status", to: "clear_status" },
      { text: "Pause", to: "pause" },
      { text: "Unpause", to: "unpause" },
      { text: "Update Number", to: "update_number" },
      { text: "MMS", to: "mms" },
      { text: "Portin", to: "portin" },
      { text: "Order Info", to: "order_info" },
      { text: "Filters", to: "filters" },
      { text: "Assign Filter Groups", to: "filter_group_assign" },
      { text: "Sim Info", to: "sim_info" },
      { text: "Plan", to: "plan" },
      { text: "Iccid Inventory", to: "iccid_inventory" },
      { text: "Maintenance Windows", to: "maintenance_windows" },
      { text: "Credential", to: "credential" },
    ],
  },
  {
    text: "VS",
    to: "/vs",
    subMenu: [
      { text: "Sim Info", to: "sim_info" },
      { text: "Update Number", to: "update_number" },
      { text: "Portin", to: "portin" },
      { text: "Credential", to: "credential" },
    ],
  },
  {
    text: "IT",
    to: "/it",
    subMenu: [
      { text: "Activate", to: "activate" },
      { text: "Change Number", to: "change_number" },
      { text: "Change SIM", to: "change_sim" },
      { text: "Refill", to: "refill" },
      { text: "Portout", to: "portout" },
      { text: "Sim Info", to: "sim_info" },
      { text: "Credential", to: "credential" },
    ],
  },
  {
    text: "Nyx",
    to: "/nyx",
    subMenu: [
      { text: "Activate", to: "activate" },
      { text: "Sim Info", to: "sim_info" },
      { text: "Deactivate", to: "deactivate" },
      { text: "Credential", to: "credential" },
    ],
  },
  {
    text: "PWG",
    to: "/pwg",
    subMenu: [
      { text: "Activate", to: "activate" },
      { text: "Change Number", to: "change_number" },
      { text: "Change SIM", to: "change_sim" },
      { text: "Deactivate", to: "deactivate" },
      { text: "Restore", to: "restore" },
      { text: "Pause", to: "pause" },
      { text: "Unpause", to: "unpause" },
      { text: "Change Plan", to: "change_plan" },
      { text: "Portin", to: "portin" },
      { text: "Wifi Calling", to: "wifi_calling" },
      { text: "Sim Info", to: "sim_info" },
      { text: "Query Usage", to: "query_usage" },
      { text: "Esim", to: "esim" },
      { text: "Plan", to: "plan" },
      { text: "Credential", to: "credential" },
    ],
  },
  {
    text: "User",
    to: "/user",
  },
];

export const userItems = [
  {
    text: "Activate",
    to: "/client/activate",
    hasNoLink: true,
  },
  {
    text: "Change Number",
    to: "/client/change_number",
    hasNoLink: true,
  },
  {
    text: "Deactivate",
    to: "/client/deactivate",
    hasNoLink: true,
  },
  {
    text: "Sim Info",
    to: "/client/sim_info",
    hasNoLink: true,
  },
  {
    text: "Reset",
    to: "/client/reset",
  },
];
